<template>
  <ValidationProvider
    :rules="_rules"
    v-slot="{ errors }"
    class="ws-state"
    :class="{ noMt: isNoMt, 'no-mt': !_displayCheck }"
  >
    <div
      class="ws-state__container"
      :class="[{ 'is-error': errors && errors.length }]"
      v-if="_displayCheck"
    >
      <div v-if="_label" class="ws-state-label">
        {{ _label }} <span v-if="required" class="red--text">*</span>
      </div>
      <div v-if="des" class="ws-state__des">{{ des }}</div>
      <WsStateInput
        v-if="
          type == 'text' ||
          type == 'password' ||
          type == 'email' ||
          type == 'link' ||
          type == 'number'
        "
        ref="WsStateInput"
        @keyup="$_onKeyup"
        :autofocus="autofocus"
        :maxWidth="maxWidth"
        :rules="rules"
        :type="type"
        :name="name"
        :errors="errors"
        :placeholder="placeholder"
        :note="note"
        :isOk="isOk"
        :errorMessage="errorMessage"
        :disabled="disabled"
        :maxlength="maxlength"
        :requiredField="requiredField"
        :requiredFieldState="requiredFieldState"
        :parentState="parentState"
        :parent="parent"
        :displayCheck="_displayCheck"
        :autocomplete="autocomplete"
        :value="value"
        :isWarning="isWarning"
        @input="$emit('input', $event)"
      ></WsStateInput>
      <WsStateTextarea
        v-else-if="type == 'textarea'"
        :value="value"
        :disabled="disabled"
        :autoGrow="autoGrow"
        :maxlength="maxlength"
        :isWarning="isWarning"
        :placeholder="placeholder"
        @input="$emit('input', $event)"
        @keyup="$_onKeyup"
      ></WsStateTextarea>
      <LvStateWYSIWYG v-else-if="type == 'editor'" :value="value" @input="$emit('input', $event)" />
      <WsStateRelationshipSelect
        v-else-if="type == 'belongsTo'"
        :placeholder="placeholder"
        :modelName="modelName"
        :parentState="parentState"
        :requiredField="requiredField"
        :requiredFieldState="requiredFieldState"
        :conditions="conditions"
        :parent="parent"
        :textKey="textKey"
        :getText="getText"
        :getValue="getValue"
        :value="value"
        :errors="errors"
        :originValue="originValue"
        @input="$emit('input', $event)"
        :note="note"
        :rules="rules"
        :errorMessage="errorMessage"
        :excludeSelf="excludeSelf"
        :modelId="modelId"
        :hasNoSearch="hasNoSearch"
        :noReset="noReset"
        :hasCloseChips="hasCloseChips"
        :parentStateName="parentStateName"
        :orderWay="orderWay"
        :orderBy="orderBy"
        :clearable="clearable"
      />
      <WsStateRelationshipSelect
        v-else-if="type == 'hasMany'"
        :placeholder="placeholder"
        :modelName="modelName"
        :conditions="conditions"
        :rules="rules"
        multiple
        :textKey="textKey"
        :getText="getText"
        :errors="errors"
        :parentState="parentState"
        :requiredField="requiredField"
        :requiredFieldState="requiredFieldState"
        :parent="parent"
        :value="value"
        :originValue="originValue"
        :excludeSelf="excludeSelf"
        :modelId="modelId"
        :orderWay="orderWay"
        :orderBy="orderBy"
        :hasNoSearch="hasNoSearch"
        :hasAllSelectBtn="hasAllSelectBtn"
        :noReset="noReset"
        :hasCloseChips="hasCloseChips"
        :parentStateName="parentStateName"
        :clearable="clearable"
        @input="$emit('input', $event)"
        @input-item="$emit('input-item', $event)"
      />
      <WsStateSwitch
        v-else-if="type == 'switch'"
        :activeText="activeText"
        :inactiveText="inactiveText"
        :defaultValue="defaultValue"
        :value="value"
        @input="$emit('input', $event)"
      ></WsStateSwitch>
      <WsStateVersion
        v-else-if="type == 'last_version'"
        :fields="fields"
        :value="value"
        :getText="getText"
        :getRules="getRules"
        :customParentData="customParentData"
        :originData="originData"
        :originDataEX="originDataEX"
        :originValue="originValue"
        @input="$emit('input', $event)"
      ></WsStateVersion>
      <WsStateDate
        v-else-if="type == 'date'"
        :value="value"
        :originData="originData"
        :getFromDate="getFromDate"
        :getEndDate="getEndDate"
        :placeholder="placeholder"
        :requiredField="requiredField"
        :requiredFieldValue="requiredFieldValue"
        @input="$emit('input', $event)"
      ></WsStateDate>
      <WsStateDatetime
        v-else-if="type == 'datetime'"
        :value="value"
        :format="format"
        :disabledDate="disabledDate"
        :disabledTime="disabledTime"
        :defaultValue="defaultValue"
        @input="$emit('input', $event)"
      ></WsStateDatetime>
      <WsStateLocales
        v-else-if="type == 'locales'"
        :fields="fields"
        :value="value"
        :originData="originData"
        :displayCheck="displayCheck"
        :getText="getText"
        @input="$emit('input', $event)"
      ></WsStateLocales>
      <WsStateFile
        v-else-if="type == 'files'"
        :value="value"
        :uploadUrl="uploadUrl"
        :parent="parent"
        :parentState="parentState"
        :customFunction="customFunction"
        :isLink="isLink"
        @input="$emit('input', $event)"
      ></WsStateFile>
      <WsStateBelongsToFile
        v-else-if="type == 'file'"
        :value="value"
        :uploadUrl="uploadUrl"
        :parent="parent"
        :parentState="parentState"
        :accept="accept"
        @input="$emit('input', $event)"
        @import-file="$emit('import-file', $event)"
      ></WsStateBelongsToFile>
      <WsStateAutocomplete
        v-else-if="type == 'tags'"
        :placeholder="placeholder"
        :modelName="modelName"
        :conditions="conditions"
        multiple
        :parentState="parentState"
        :parent="parent"
        :value="value"
        @input="$emit('input', $event)"
      ></WsStateAutocomplete>
      <WsStateSelect
        v-else-if="type == 'select'"
        :items="items"
        :placeholder="placeholder"
        :defaultValue="defaultValue"
        :value="value"
        :clearable="clearable"
        @input="$emit('input', $event)"
      ></WsStateSelect>
      <WsStateSelect
        v-else-if="type == 'multi-select'"
        :items="items"
        :defaultValue="defaultValue"
        :value="value"
        :clearable="clearable"
        multiple
        @input="$emit('input', $event)"
      ></WsStateSelect>
      <WsStateRadio
        v-else-if="type == 'radio'"
        :items="items"
        :defaultValue="defaultValue"
        :disabled="disabled"
        :value="value"
        :getItems="getItems"
        :getUrl="getUrl"
        :params="getParams ? getParams(originData) : {}"
        :getValue="getValue"
        :setValue="setValue"
        @input="$emit('input', $event)"
      ></WsStateRadio>
      <WsStateCheckbox
        v-else-if="type == 'checkbox'"
        :items="items"
        :defaultValue="defaultValue"
        :disabled="disabled"
        :value="value"
        @input="$emit('input', $event)"
      >
      </WsStateCheckbox>
      <WsStateImage
        v-else-if="type == 'image'"
        :value="value"
        :uploadUrl="uploadUrl"
        :maxWidth="maxWidth"
        :parent="parent"
        :parentState="parentState"
        @input="$emit('input', $event)"
      ></WsStateImage>
      <WsStateImages
        v-else-if="type == 'images'"
        :value="value"
        :uploadUrl="uploadUrl"
        :maxWidth="maxWidth"
        :parent="parent"
        :parentState="parentState"
        @input="$emit('input', $event)"
      ></WsStateImages>
      <WsStateMultipleLayerSelect
        v-else-if="type == 'multiple-layer-select'"
        :placeholder="placeholder"
        :modelName="modelName"
        :conditions="conditions"
        :rules="rules"
        :textKey="textKey"
        :getText="getText"
        :errors="errors"
        :parentState="parentState"
        :requiredField="requiredField"
        :requiredFieldState="requiredFieldState"
        :parent="parent"
        :value="value"
        :originValue="originValue"
        :excludeSelf="excludeSelf"
        :modelId="modelId"
        :orderWay="orderWay"
        :orderBy="orderBy"
        :getUrl="getUrl"
        @input="$emit('input', $event)"
      ></WsStateMultipleLayerSelect>
      <WsStateSwitchTab
        v-else-if="type === 'switch-tabs'"
        :items="items"
        :defaultValue="defaultValue"
        :requiredFieldState="requiredFieldState"
        :requiredFieldValue="requiredFieldValue"
        @input="$emit('input', $event)"
        :value="value"
      ></WsStateSwitchTab>
      <WsStateActPicker
        v-else-if="type === 'act-picker'"
        :requiredField="requiredField"
        :requiredFieldState="requiredFieldState"
        :originDataEX="originDataEX"
        :customParentData="customParentData"
        :conditions="conditions"
        hasCloseChips
        @input="$emit('input', $event)"
      ></WsStateActPicker>
      <WsStateMultiLayer
        v-else-if="type === 'multi-layer'"
        :placeholder="placeholder"
        :modelName="modelName"
        :getUrl="getUrl"
        :value="value"
        :errors="errors"
        :multiple="multiple"
        :layersSetting="layersSetting"
        :valueKey="valueKey"
        :textKey="textKey"
        :requiredFieldState="requiredFieldState"
        :conditions="conditions"
        @input="$emit('input', $event)"
      ></WsStateMultiLayer>
      <v-color-picker
        v-else-if="type == 'color'"
        :value="value"
        @input="$emit('input', $event)"
      ></v-color-picker>
      <LvStateOptionItem
        v-else-if="type == 'optionItem'"
        :value="value"
        @input="$emit('input', $event)"
      />
      <LvStateOption v-else-if="type == 'option'" :value="value" @input="$emit('input', $event)" />
      <LvStateNumericalComparisonConditionSetting
        v-else-if="type == 'numericalComparisonConditionSetting'"
        :value="value"
        @input="$emit('input', $event)"
      />
      <LvStateDate
        v-else-if="type == 'dateDuration'"
        :isDuration="true"
        :value="value"
        @input="$emit('input', $event)"
      />
      <input type="hidden" :value="value" />
      <div v-if="errors && errors.length" class="ws-state__detail">
        <v-icon size="20">mdi-information</v-icon>
        <p>{{ $_error(errors) }}</p>
      </div>
      <div v-if="verify.message" class="ws-state__verify" :class="[verify.check]">
        <v-icon size="20">mdi-information</v-icon>
        <p>{{ verify.message }}</p>
      </div>
      <div v-if="note" class="ws-state__detail"></div>
      <div class="ws-state__verify" v-if="verifyApi">
        <WsBtn @click="$_onVerify()" minWidth="100px" :loading="loading.verify" color="primary"
          >驗證</WsBtn
        >
      </div>
    </div>
  </ValidationProvider>
</template>

<script>
import { extend } from 'vee-validate';
import { required, email, min, max, between, min_value, max_value } from 'vee-validate/dist/rules';
import locales from '@/locales/zh_tw';
extend('max', {
  ...max,
  // message: "不得多於{length}位"
  message: locales['validate-max'],
});
extend('min', {
  ...min,
  // message: "不得少於{length}位"
  message: locales['validate-min'],
});
extend('between', {
  ...between,
  // message: "不得少於{length}位"
  message: locales['validate-min'],
});
extend('required', {
  ...required,
  // message: "此項目為必填"
  message: locales['validate-required'],
});
extend('email', {
  ...email,
  // message: "email格式不符"
  message: locales['validate-email'],
});
extend('min_value', {
  ...min_value,
  // message: "不得少於{length}位"
  message: '不得少於{min}',
});
extend('max_value', {
  ...max_value,
  // message: "不得少於{length}位"
  message: '不得大於{max}',
});
extend('nospace', {
  validate: (value) => {
    if (/\s/.test(value)) {
      return false;
    } else {
      return true;
    }
  },
  // message: "密碼不可為空格"
  message: locales['validate-no-space'],
});
extend('nospace', {
  validate: (value) => {
    if (/\s/.test(value)) {
      return false;
    } else {
      return true;
    }
  },
  // message: "密碼不可為空格"
  message: locales['validate-no-space'],
});
extend('str_confirmed', {
  validate: (value, [str]) => {
    console.log(value, str);
    if (value == str) {
      return true;
    } else {
      return false;
    }
  },
  // message: "密碼不可為空格"
  message: locales['validate-str-confirmed'],
});
export default {
  data: () => ({
    text: 4,
    loading: {
      verify: false,
    },
    verify: {
      message: '',
      check: 'success',
    },
  }),
  computed: {
    _label() {
      if (this.displayLabel) {
        return this.label;
      } else {
        return null;
      }
    },
    _displayCheck() {
      if (this.displayCheck) {
        if (this.displayCheck(this.originData)) {
          return true;
        } else {
          return this.displayCheck(this.originData);
        }
      } else {
        return true;
      }
    },
    _rules() {
      if (this.getRules) {
        if (!this.getRules(this.originData)) {
          return this.rules;
        }
        return this.getRules(this.originData);
      } else {
        return this.rules;
      }
    },
    _rulesErrorMessage() {
      if (this.rulesErrorMessage) {
        return this.rulesErrorMessage(this.originData);
      } else {
        return null;
      }
    },
  },
  methods: {
    $_onKeyup($event) {
      this.$emit('keyup', $event);
    },
    focus() {
      if (
        this.type == 'text' ||
        this.type == 'email' ||
        this.type == 'search' ||
        this.type == 'password'
      ) {
        this.$refs.WsStateInput.focus();
      }
    },
    $_error(errors) {
      if (errors && errors.length) {
        if (this._rulesErrorMessage) {
          return this._rulesErrorMessage;
        } else if (this.errorMessage) {
          return this.errorMessage;
        } else {
          return errors[0];
        }
      } else {
        return null;
      }
    },
    async $_onVerify() {
      try {
        this.loading.verify = true;
        const res = await this.$axios.post(this.verifyApi.url, {
          [this.verifyApi.postKey]: this.value,
        });
        this.verify.message = this.verifyApi.successMessage(res.data.data);
        this.verify.check = 'success';
      } catch (err) {
        this.verify.message = this.verifyApi.errorMessage(err.response.data.message);
        this.verify.check = 'fail';
      } finally {
        this.loading.verify = false;
      }
    },
  },
  mounted() {
    if (this.autofocus) {
      this.$refs.WsStateInput.focus();
    }
  },
  props: {
    maxlength: {
      type: Number,
      default: null,
    },
    modelId: {
      type: [Number, String],
      default: null,
    },
    originValue: {},
    excludeSelf: {
      type: Boolean,
      default: false,
    },
    displayLabel: {
      type: Boolean,
      default: true,
    },
    getText: {
      type: Function,
      default: null,
    },
    getValue: {
      type: Function,
      default: null,
    },
    textKey: {
      type: String,
      default: 'name',
    },
    valueKey: {
      type: String,
      default: 'id',
    },
    requiredFieldState: {},
    requiredField: {
      type: String,
      default: null,
    },
    requiredFieldValue: {
      type: String,
    },
    autoGrow: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: null,
    },
    uploadUrl: {
      type: String,
      default: null,
    },
    activeText: {
      type: String,
      default: null,
    },
    inactiveText: {
      type: String,
      default: null,
    },
    conditions: {
      type: Array,
      default: null,
    },
    maxWidth: {
      type: String,
      default: null,
    },
    fields: {
      type: Object,
      default: null,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'text',
    },
    label: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
    },
    note: {
      type: String,
      default: null,
    },
    errorMessage: {
      type: String,
      default: null,
    },
    isOk: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {},
    name: {
      type: String,
      default: null,
    },
    rules: {
      type: String,
      default: null,
    },
    modelName: {
      type: String,
      default: null,
    },
    parentState: {},
    parent: {
      type: String,
      default: null,
    },
    orderBy: {
      type: String,
      default: '',
    },
    orderWay: {
      type: String,
      default: '',
    },
    isNoMt: {
      type: Boolean,
      default: false,
    },
    getUrl: {
      type: String,
      default: '',
    },
    hasNoSearch: {
      type: Boolean,
      default: false,
    },
    hasAllSelectBtn: {
      type: Boolean,
      default: false,
    },
    noReset: {
      type: Boolean,
      default: false,
    },
    hasCloseChips: {
      type: Boolean,
      default: false,
    },
    displayCheck: {
      type: Function,
      default() {
        return {};
      },
    },
    originData: {
      type: Object,
    },
    originDataEX: {
      type: Object,
    },
    defaultValue: {
      type: [String, Number, Boolean, Array],
      default: null,
    },
    customParentData: {
      type: Object,
    },
    compareStr: {
      type: Function,
      default() {
        return {};
      },
    },
    getRules: {
      type: Function,
    },
    getFromDate: {
      type: Function,
    },
    getEndDate: {
      type: Function,
    },
    rulesErrorMessage: {
      type: Function,
    },
    parentStateName: {
      type: String,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    verifyApi: {
      type: Object,
    },
    autocomplete: {
      type: String,
    },
    accept: {
      type: String,
      default: null,
    },
    des: {
      type: String,
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    layersSetting: {
      type: Object,
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD HH:mm:ss',
    },
    customFunction: {
      type: Function,
    },
    isLink: {
      type: Boolean,
      default: true,
    },
    getItems: {
      type: Function,
    },
    getParams: {
      type: Function,
    },
    setValue: {
      type: Function,
    },
    disabledDate: {
      type: Function,
    },
    disabledTime: {
      type: Function,
    },
    required: {
      type: Boolean,
      default: false,
    },
    isWarning: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
@import '../assets/scss/ws-state.scss';
</style>
